import { render } from "./CustomDropDownOld.vue?vue&type=template&id=3f6b2cc6"
import script from "./CustomDropDownOld.vue?vue&type=script&lang=js"
export * from "./CustomDropDownOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__